
import { Alert, Platform } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'
// import * as firebase from 'firebase/app'
import * as types from './types'
import error from '../../config/error'
import DirectusApi from '../../lib/directus.api'
import ActionCreators from '.'

const isWeb = Platform.OS === 'web'

const finishOnboardingSuccess = () => ({
  type: types.FINISH_ONBOARDING,
})

export const initApp = () => async (dispatch: Function, state: Function) => {
  // const { loggedIn } = state().user

  // TODO: Remove later
  if (
    isWeb &&
    localStorage.getItem('has_reset_localstorage') === null
  ) {
    localStorage.setItem('has_reset_localstorage', '1')
    dispatch(ActionCreators.logoutUser())
    return
  }

  const { data: { data: result } } = await DirectusApi.get('/items/globals', {
    // params: {
    //   fields: '*.*.*'
    // }
  })

  dispatch({
    type: types.INIT_APP,
    payload: result
  })
}

export const logError = ({
  code,
  message,
}: {
  code: string
  message: string
}) => {
  return {
    type: types.ERROR,
    code,
    message
  }
}

export const handleError = ({
  code,
  message,
}: {
  code: string
  message?: string
}) => (dispatch: Function, state: Function) => {
  // TODO: Change generic message later to user friendly text
  const genericTitle = 'Fehler'
  const errorTitle =
    error[code] && error[code].title ? error[code].title : genericTitle

  const genericMessage = `${code ? `${code}: ` : ''} ${message}`
  const errorMessage =
    error[code] && error[code].message ? error[code].message : genericMessage

  dispatch(logError({ code, message }))

  if (!isWeb) {
    Alert.alert(errorTitle, errorMessage, [{ style: 'default', text: 'OK' }], { cancelable: true })
  } else {
    // eslint-disable-next-line no-alert
    alert(errorMessage)
  }

  // TODO: Improve error handling

  // if (message === 'Request failed with status code 403' || message === 'Request failed with status code 401') {
  //   dispatch(logoutUser())
  // }
}

export const finishOnboarding = () => (dispatch: Function) => {
  return new Promise((resolve, reject) => {
    AsyncStorage.setItem('@HGStore:skipOnboarding', '1', (err) => {
      if (!err) {
        dispatch(finishOnboardingSuccess())
        resolve()
      } else {
        reject()
      }
    })
  })
}

export const resetOnboarding = () => (dispatch: Function) => {
  AsyncStorage.removeItem('@HGStore:skipOnboarding', (err) => {
    if (!err) {
    }
    dispatch({ type: types.RESET_ONBOARDING })
  })
}

export const setPatientGroup = ({ patientGroup }: { patientGroup: string }) => (
  dispatch: Function
) => {
  if (
    patientGroup === 'children' ||
    patientGroup === 'adults' ||
    patientGroup === 'caredependents'
  ) {
    return AsyncStorage.setItem(
      '@HGStore:patientGroup',
      patientGroup,
      (err) => {
        if (!err) {
          dispatch({
            type: types.SET_PATIENT_GROUP,
            patientGroup,
          })
          dispatch(togglePatientGroupModal({ toggle: false }))
          // resolve()
        } else {
          // reject()
        }
      }
    )
  }

  // remove...
  return AsyncStorage.removeItem('@HGStore:patientGroup', (err) => {
    if (!err) {
    }
    dispatch({
      type: types.SET_PATIENT_GROUP,
      patientGroup: null,
    })
  })
}

export const togglePatientGroupModal = ({ toggle }: { toggle: boolean }) => ({
  type: types.TOGGLE_PATIENT_GROUP_MODAL,
  patientGroupModalVisible: toggle,
})

export const getResourceKey = ({ routeName }: { routeName: string }) => (
  dispatch: Function,
  state: Function
) => {
  const theState = state()
  const { patientGroup } = theState.user

  if (!patientGroup || !patientGroup.length) return false

  return `${patientGroup}-${routeName}`.toLowerCase()
}

export const setCurrentResource = ({ routeName }: { routeName: string }) => (
  dispatch: Function,
  state: Function
) => {
  const resourceKey = getResourceKey({ routeName })(dispatch, state)

  dispatch({
    type: types.SET_CURRENT_RESOURCE,
    resourceKey,
  })
}

export const loadBlock = ({ id, blockType }: { id: string, blockType: 'content_menus' }) => async (dispatch: () => void, state: () => unknown) => {

  const { data: { data: result } } = await DirectusApi.get(`/items/${blockType}/${id}`, {
    params: {
      fields: '*.*.*'
    }
  })
  return result
}

/**
 * Loads a resource via the API identified by the requested route
 * @param {string} resourceId
 */
export const loadResource = ({ resourceId }: { resourceId: string }) => async (
  dispatch: Function,
  state: Function
) => {
  // const { accessToken } = state().user
  // const key = getResourceKey({ routeName })(dispatch, state)

  // const resource =
  //   state().resources && state().resources.list[key]
  //     ? state().resources.list[key]
  //     : null

  /*
  if (resource) {
    // dispatch({
    //   type: types.SET_CURRENT_RESOURCE,
    //   resourceKey: key
    // })
    return new Promise((resolve, reject) => resolve(resource))
  }
  */

  // if (!accessToken) {
  //   return Error('No accessToken given')
  // }
  try {
    const { data: { data: result } } = await DirectusApi.get(`/items/resources/${resourceId}`, {
      params: {
        fields: '*.*.*.*.*'
      }
    })
    dispatch({
      type: types.SET_RESOURCE,
      resourceKey: result?.slug,
      resourceData: result,
    })
    return result
  } catch (reason) {
    throw new Error(reason.message)
  }

}
